/* eslint-disable default-case */
import React, { useState, useEffect } from 'react';
import {
   Table, Space, Tooltip, Button, Input, Row, Col,
   Modal, Image, Skeleton
} from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import { DownloadOutlined, EyeOutlined, FileTextOutlined, SearchOutlined } from '@ant-design/icons';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import moment from 'moment';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { Link } from "react-router-dom";
import '../common/BraineeModule.css';
import './Soa.css';

var g_soa_url = "";
var g_subdomain = "";
var g_upload_date = "";

export default function Soa() {
   const [searchText, setSearchText] = useState("");
   const [searchedColumn, setSearchedColumn] = useState("");

   const [listLoading, setListLoading] = useState(false);
   const [soaList, setSoaList] = useState([]);
   const [modalVisible, setModalVisible] = useState(false);
   const [downloadStatus, setDownloadStatus] = useState(false);

   g_subdomain = localStorage.getItem("lms-subdomain");

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);

   useEffect(() => {
      Utils.verifyJwt();

      getSOAList(user_id);
   }, []);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#033D89' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const SoaListColumns = [
      {
         title: 'Title',
         key: 'title',
         dataIndex: 'title',
         width: '50%',
         ...getColumnSearchProps('title')
      },
      {
         title: 'Upload Date',
         key: 'date_created',
         dataIndex: 'date_created',
         width: '30%',
         ...getColumnSearchProps('date_created')
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return (
               <>
                  <Space size="small">

                     {payload.file_url !== null && payload.file_url !== "" &&
                        <>
                           <Tooltip placement="top" title={'View Statement of Account'}>
                              <Button
                                 type="text"
                                 shape="circle"
                                 className="soa-view-btn"
                                 icon={<EyeOutlined />}
                                 onClick={() => handlePreview(payload.file_url, payload.date_created)}
                              />
                           </Tooltip>
                        </>
                     }
                  </Space>
               </>
            );
         },
         width: '20%'
      },
   ].filter(item => !item.hidden);

   const renderPreviewer = (document) => {
      if (document !== null && document !== '' && modalVisible) {
         var re = /(?:\.([^.]+))?$/;
         var ext = re.exec(document.toLowerCase());

         var subdomain = localStorage.getItem("lms-subdomain");
         var url = `${process.env.REACT_APP_API_S3_URL}/${subdomain}/${document}`;

         switch (ext[1]) {
            case "pdf":
               return <>
                  <div style={{ width: "100%", height: "calc(100vh - 185px)" }}>
                     <Worker workerUrl={process.env.PUBLIC_URL + "/js/pdf.worker.min.js"}>
                        <Viewer
                           pageLayout={{
                              transformSize: ({ size }) => ({
                                 height: size.height + 30,
                                 width: size.width + 30,
                              }),
                           }}
                           fileUrl={url}
                           defaultScale={SpecialZoomLevel.PageWidth}
                           initialPage={0}
                        />
                     </Worker>
                  </div>
               </>

            case "png": case "jpg": case "jpeg":
               return <>
                  <div
                     className={'modal-document-viewer'}
                     style={{ height: "calc(100vh - 195px)" }}
                  >
                     <Image
                        src={url}
                        style={{ minHeight: "calc(100vh - 195px)", maxHeight: "calc(100vh - 195px)" }}
                     />
                  </div>
               </>
         }
      }
   }

   const getSOAList = (id) => {
      setListLoading(true);
      var url = `${process.env.REACT_APP_API_CPH}/getsoa?id=${id}`;
      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;
            setSoaList(data);
         }
         setListLoading(false);
      }, (error) => {
         console.log(error.message);
         setListLoading(false);
      });
   }

   const handlePreview = (soa_url, upload_date) => {
      g_soa_url = soa_url;
      g_upload_date = moment(upload_date).format("MM-DD-YYYY");
      setModalVisible(true);
   }

   const _downloadFile = (url, name) => {
      setDownloadStatus(true);

      var re = new RegExp(' ', 'g');
      var file_name = "soa_" + name.replace(re, '_');
      var pos = url.lastIndexOf('.');
      var ext = url.slice(pos);

      fetch(url)
         .then(response => {
            response.blob().then(blob => {
               let url = window.URL.createObjectURL(blob);
               let a = document.createElement('a');
               a.href = url;
               a.download = file_name + ext;
               a.click();
               setDownloadStatus(false)
            });
         });
   };

   const handleModalClose = () => {
      setModalVisible(false);
   }

   const renderSkeletonTable = () => (
      <div className="brainee-module-skeleton-table">
         <div className="brainee-module-skeleton-header">
            <Skeleton.Input active size="small" className="brainee-module-skeleton-title" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-chip" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-action" />
         </div>
         {[0, 1, 2, 3, 4].map((item) => (
            <div className="brainee-module-skeleton-row soa-skeleton-row" key={item}>
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell is-wide" />
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
               <Skeleton.Button active size="small" className="brainee-module-skeleton-action" />
            </div>
         ))}
      </div>
   );

   return (
      <>
         <div className="dashboard-area-all brainee-module-page soa-page">
            <div className="dashboard-item brainee-module-shell soa-shell">
               <div className="brainee-module-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'soa', node: 'Statement of Accounts' },
                     ]}
                  />
               </div>

               <section className="brainee-module-hero soa-hero">
                  <div>
                     <span className="brainee-module-kicker">Finance</span>
                     <h1>Statement of Accounts</h1>
                     <p>Review uploaded billing statements, open each document, and download a copy when needed.</p>
                     <div className="brainee-module-meta">
                        <span><strong>{listLoading ? '...' : soaList.length}</strong> {listLoading ? 'Loading statements' : 'Statements'}</span>
                     </div>
                  </div>
                  <div className="soa-hero-icon" aria-hidden="true">
                     <FileTextOutlined />
                  </div>
               </section>

               <section className="brainee-module-panel soa-panel">
                  <div className="brainee-module-panel-header">
                     <div>
                        <span className="brainee-module-kicker">Records</span>
                        <h2>Uploaded statements</h2>
                     </div>
                     <span className="brainee-module-count">{listLoading ? '...' : soaList.length}</span>
                  </div>

                  {listLoading ? (
                     renderSkeletonTable()
                  ) : (
                     <div className="brainee-module-table-shell">
                        <Table
                           className="brainee-module-table soa-table"
                           rowKey={'uid'}
                           size='small'
                           columns={SoaListColumns}
                           dataSource={soaList}
                           pagination={false}
                           scroll={{
                              x: '720px',
                              y: 'calc(100svh - 25rem)',
                           }}
                           footer={() => <div className="brainee-module-table-footer"><span>Total Records: {soaList.length}</span></div>}
                        />
                     </div>
                  )}
               </section>
            </div>
         </div>

         <Modal
            title={"Statement of Account"}
            // okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ shape: "round" }}
            centered
            destroyOnClose={true}
            open={modalVisible}
            // width={window.innerWidth - 300}
            width='75%'

            onCancel={() => { handleModalClose(); }}
            onOk={() => { handleModalClose(); }}
            className="soa-preview-modal"
            footer={[
               <Row className="soa-preview-footer" key="soa-preview-footer">
                  <Col xs={24} sm={12} className="soa-preview-footer-left">
                     <Button
                        shape='round'
                        type="primary"
                        loading={downloadStatus}
                        icon={<DownloadOutlined />}
                        className="brainee-module-create-btn"
                        onClick={() => _downloadFile(`${process.env.REACT_APP_API_S3_URL}/${g_subdomain}/${g_soa_url}`, g_upload_date)}
                     >
                        Download
                     </Button>
                  </Col>
                  <Col xs={24} sm={12} className="soa-preview-footer-right">
                     <Button shape='round' className="soa-preview-close-btn" onClick={() => { handleModalClose(); }}>
                        Close
                     </Button>
                  </Col>
               </Row>,
            ]}
         >
            <div className='essay_list_container soa-preview-body'>
               {renderPreviewer(g_soa_url)}
            </div>
         </Modal>
      </>
   );
}

